import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
// Partials
import { PartialsModule } from 'src/app/views/partials/partials.module';
// Components
import { PolicyDetailComponent } from './policy-detail/policy-detail.component';
//Material
// import { MatTabsModule } from '@angular/material/tabs';
// import { MatCardModule } from '@angular/material/card';
// import { MatTableModule } from '@angular/material/table';
// import { MatIconModule } from '@angular/material/icon';
// import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
// import { MatPaginatorModule } from '@angular/material/paginator';
// import { MatTooltipModule } from '@angular/material/tooltip';
// import { MatSortModule } from '@angular/material/sort';
import { MatButtonModule } from '@angular/material/button';
// import { MatCheckboxModule } from '@angular/material/checkbox';
// import { MatFormFieldModule } from '@angular/material/form-field';
// import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
// import { MatAutocompleteModule } from '@angular/material/autocomplete';
// Modal
import { DetailModal } from './policy-detail/detail-modal/detail-modal.component';
import { CoreModule } from '../../core/core.module';

@NgModule({
  declarations: [PolicyDetailComponent, DetailModal],
  imports: [
    CommonModule,
    PartialsModule,
    MatSelectModule,
    MatButtonModule,
    CoreModule

  ],
  exports: [PolicyDetailComponent]
})
export class ComponentsModule { }
